import { Button, cx } from "@light-technology/components";
import { ArrowLeft, ArrowRight } from "@untitledui/icons";
import { SkeletonLine } from "../shared/SkeletonLine";

export { SkeletonLine };

export const SkeletonImage = ({
  className,
  subtle = false,
}: {
  className?: string;
  subtle?: boolean;
}) => (
  <div
    className={cx(
      "animate-pulse rounded",
      subtle ? "bg-fg-disabled_subtle" : "bg-fg-disabled",
      className,
    )}
    role="status"
  />
);

export const PlaybookCardSkeleton = ({ className }: { className?: string }) => (
  <div
    className={cx(
      "mt-2 mr-1 flex flex-col justify-between rounded-2xl border border-secondary bg-primary p-6",
      className,
    )}
  >
    <div className="flex flex-col gap-3xl">
      <div className="flex flex-col gap-1 text-sm leading-5">
        <div className="font-semibold">
          <SkeletonLine className="w-3/4" />
          <SkeletonLine className="w-4/5" />
        </div>
        <div>
          <SkeletonLine subtle className="w-full" />
          <SkeletonLine subtle className="w-2/3" />
          <SkeletonLine subtle className="w-4/5" />
        </div>
      </div>
      <div className="flex items-center justify-end">
        <ArrowRight className="size-5 text-fg-disabled" />
      </div>
    </div>
  </div>
);

export const PlaybookSectionSkeleton = () => (
  <div className="flex flex-col gap-xl">
    <div>
      <div className="text-xl font-semibold">
        <SkeletonLine className="w-full max-w-64" />
      </div>
      <p className="text-md">
        <SkeletonLine className="w-full max-w-122" subtle />
      </p>
    </div>
    <div
      className={cx(
        "grid grid-flow-col gap-4 overflow-hidden",
        "auto-cols-[100%] @page-sm:auto-cols-[calc((100%-24px)/2)] @page-md:auto-cols-[calc((100%-32px)/3)]",
      )}
    >
      <PlaybookCardSkeleton className="flex-1" />
      <PlaybookCardSkeleton className="flex-1" />
      <PlaybookCardSkeleton className="flex-1" />
    </div>
    <div className="flex items-center justify-between">
      <div className="flex gap-3">
        <Button
          isDisabled
          color="secondary"
          iconTrailing={<ArrowLeft className="size-5" />}
        />
        <Button
          isDisabled
          color="secondary"
          iconTrailing={<ArrowRight className="size-5" />}
        />
      </div>
      <Button isDisabled color="secondary">
        View all
      </Button>
    </div>
  </div>
);

export const GuideBodySkeleton = () => (
  <div>
    {Array.from({ length: 5 }).map((_, i) => (
      <div key={i}>
        <h2 className="mt-2xl text-lg font-semibold">
          <SkeletonLine className="w-2/5" />
        </h2>
        <p className="mt-md text-sm leading-6">
          <SkeletonLine className="w-full" subtle />
          <SkeletonLine className="w-full" subtle />
          <SkeletonLine className="w-3/4" subtle />
        </p>
        <p className="mt-md text-sm leading-6">
          <SkeletonLine className="w-full" subtle />
          <SkeletonLine className="w-5/6" subtle />
        </p>
      </div>
    ))}
  </div>
);

export const FAQBodySkeleton = () => (
  <div className="text-sm leading-6">
    <SkeletonLine className="w-full" subtle />
    <SkeletonLine className="w-5/6" subtle />
    <SkeletonLine className="w-3/4" subtle />
  </div>
);
